// English strings for P7-B (NOTIFY-01/02/04/05, MAIL-01) (D-013: English only). Owned by that worker;
// spread into `en` as `en.notifications`, so keys read `t("notifications.…")`. Copy rules: DESIGN_SYSTEM §9.6.
// `events.<event with "." → "_">.title` is the notification's title (the server stores the key and the
// params; amounts are present only for members with payments.read).
export const notificationsStrings = {
  centre: {
    title: "Notifications",
    lead: "Orders, payments, stock and jobs that need your attention.",
    empty: "You're all caught up.",
    emptyUnread: "No unread notifications.",
    all: "All",
    unread: "Unread",
    unreadCount: "{count} unread",
    markRead: "Mark as read",
    markAllRead: "Mark all as read",
    markedAllRead: "All notifications marked as read",
    loadMore: "Show older",
    viewAll: "See all notifications",
    amount: "Amount: {amount}",
    live: "Live",
    polling: "Updates every 30 seconds",
    pollingShort: "Every 30 s",
    retention: "Notifications are kept for 90 days.",
  },
  // "See all notifications" popup (owner, 2026-10-25).
  all: {
    close: "Close",
    kept: "Kept for 90 days",
    today: "Today",
    yesterday: "Yesterday",
    types: {
      all: "All types",
      orders: "Orders",
      payments: "Payments",
      stock: "Stock",
      billing: "Plan and wallet",
      other: "Other",
    },
    noneType: "Nothing of this type.",
    noNotices: "No messages from Adyvance yet.",
    when: "When",
    amount: "Amount",
    type: "Type",
    goTo: { orders: "Go to Orders", inventory: "Go to Inventory", wallet: "Go to Wallet" },
    markUnread: "Mark as unread",
    settings: "Notification settings",
    page: "Open full page",
  },
  bell: {
    label: "Notifications",
    labelUnread: "Notifications, {count} unread",
    many: "9+",
  },
  events: {
    order_new: { title: "New order #{number}", pref: "New orders" },
    order_first: { title: "Your first order: #{number}", pref: "Your shop's first order" },
    order_cancelled: { title: "Order #{number} was cancelled", pref: "Cancelled orders" },
    payment_failed: { title: "Payment failed for order #{number}", pref: "Failed payments" },
    payment_proof_submitted: {
      title: "Payment proof to check for order #{number}",
      pref: "Payment proofs to check",
    },
    inventory_low_stock: { title: "Low stock: {available} left", pref: "Low stock" },
    shipment_exception: {
      title: "Delivery problem for order #{number}",
      pref: "Delivery problems",
    },
    return_requested: { title: "Return requested for an order", pref: "Return requests" },
    billing_renewal_due: { title: "Your plan renews soon", pref: "Plan renewal reminders" },
    billing_wallet_low: { title: "Your wallet balance is low", pref: "Low wallet balance" },
    billing_renewed: { title: "Your plan renewed from the wallet", pref: "Plan renewed" },
    billing_renewal_failed: {
      title: "Plan renewal needs money in your wallet",
      pref: "Plan renewal failed",
    },
    import_finished: {
      title: "Import finished: {ok} imported, {failed} failed",
      pref: "Finished imports",
    },
    ai_root_stopped: {
      title:
        "root stopped answering chats: no root AI credits left. Buy credits, then turn root on.",
      pref: "root stopped (no credits)",
    },
    system_digest: {
      title: "Your summary: {total} notifications, {unread} unread",
      pref: "Summary",
    },
    store_opened: { title: "{store} is open", pref: "Shop opened (welcome email)" },
    report_weekly: { title: "Your weekly report for {store} is ready", pref: "Weekly report" },
    report_monthly: { title: "Your monthly report for {store} is ready", pref: "Monthly report" },
    fallback: { title: "New notification", pref: "Other" },
  },
  prefs: {
    title: "Your notifications",
    lead: "Choose how you hear about each kind of event. These settings are yours only.",
    event: "Event",
    channel: {
      inapp: "In the app",
      push: "Push",
      email: "Email",
      sms: "SMS",
    },
    emailPending:
      "Email isn't available yet: it needs Cloudflare Email Sending. Your choice is saved.",
    smsPending: "Staff SMS isn't available yet.",
    saved: "Notification settings saved",
    save: "Save",
    digest: {
      title: "Summary email",
      daily: "Daily (08:00 Nepal time)",
      weekly: "Weekly (Sunday, 08:00 Nepal time)",
    },
  },
  push: {
    title: "Push notifications on this device",
    lead: "Get alerts on this browser even when Adyvance is closed.",
    enable: "Turn on push",
    disable: "Turn off push",
    enabled: "Push is on for this device.",
    disabled: "Push is off for this device.",
    unsupported: "This browser can't receive push notifications.",
    denied: "Notifications are blocked for this site. Allow them in your browser settings.",
    pending: "Push isn't set up on this server yet (blocked: activation required).",
    turnedOn: "Push turned on",
    turnedOff: "Push turned off",
  },
  templates: {
    title: "Customer messages",
    lead: "The SMS and emails customers get about their orders. Use the variables below; nothing else runs.",
    event: {
      order_created: "Order received",
      order_confirmed: "Order confirmed",
      order_shipped: "Order shipped",
      order_delivered: "Order delivered",
      order_cancelled: "Order cancelled",
      payment_verified: "Payment received",
      payment_rejected: "Payment not confirmed",
    },
    channel: { sms: "SMS", email: "Email" },
    subject: "Subject",
    body: "Message",
    variables: "Variables",
    custom: "Edited",
    default: "Default",
    edit: "Edit",
    save: "Save template",
    saved: "Template saved",
    preview: "Preview",
    segments: { one: "{count} SMS segment", other: "{count} SMS segments" },
    encoding: { gsm7: "Standard characters (GSM-7)", ucs2: "Unicode (UCS-2): Nepali or emoji" },
    cost: "Estimated cost: {cost}",
    noRate: "No SMS price is set yet (blocked: activation required).",
    smsPending: "SMS sending is blocked: activation required (no SMS provider yet).",
    emailPending: "Email sending is blocked: activation required (Cloudflare Email Sending).",
  },
  senders: {
    title: "Sender identities",
    lead: "The email domain or SMS sender ID your messages come from.",
    kind: { email_domain: "Email domain", sms_sender_id: "SMS sender ID" },
    value: "Domain or sender ID",
    add: "Add sender",
    added: "Sender added",
    verify: "Verify",
    remove: "Remove",
    removed: "Sender removed",
    state: { pending: "Pending", verified: "Verified", failed: "Failed" },
    emailPending:
      "Verification needs Cloudflare Email Sending and your domain on Cloudflare (blocked: activation required).",
    smsPending:
      "A dedicated SMS sender ID is registered by the SMS provider (blocked: activation required).",
    ownerOnly: "Only an Owner can change sender identities.",
    empty: "No sender identities yet. Messages use the Adyvance defaults.",
  },
  aliases: {
    title: "Email forwarding",
    lead: "Forward an address on your domain (like sales@yourshop.com) to an inbox you already use.",
    alias: "Address",
    forwardTo: "Forward to",
    add: "Add forwarding",
    added: "Forwarding added",
    remove: "Remove",
    removed: "Forwarding removed",
    state: {
      pending: "Pending: needs the domain on Cloudflare",
      active: "Active",
      disabled: "Off",
    },
    ownerOnly: "Only an Owner can change email forwarding.",
    empty: "No forwarding addresses yet.",
    taken: "This address is already used.",
  },
  settings: {
    title: "Notifications and messages",
  },
} as const;
